export type ToastKind = 'success' | 'error' | 'info';
export interface ToastDetail { id: string; message: string; kind: ToastKind }

let seq = 0;

/** Fire a transient toast notification (rendered by <Toaster/> in the shell). */
export function toast(message: string, kind: ToastKind = 'success'): void {
  const detail: ToastDetail = { id: `t${++seq}-${message.length}`, message, kind };
  window.dispatchEvent(new CustomEvent<ToastDetail>('atlas-toast', { detail }));
}
